(function () {
  var banner = document.querySelector('.banner');
  if (!banner) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof THREE === 'undefined') return;

  var container = document.createElement('div');
  container.className = 'ballpit-container';
  container.setAttribute('aria-hidden', 'true');
  banner.insertBefore(container, banner.firstChild);

  var COLORS = [0xc6ff3d, 0xff5ca6, 0xf3f0e6, 0x1a1a1a];
  var COUNT = 55;
  var GRAVITY = -0.0022;
  var FRICTION = 0.985;
  var WALL_BOUNCE = 0.72;
  var CURSOR_RADIUS = 1.6;
  var CURSOR_FORCE = 0.05;

  var bounds = { x: 6, y: 3.4, z: 1.6 };

  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
  camera.position.set(0, 0, 12);

  var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  container.appendChild(renderer.domElement);

  scene.add(new THREE.AmbientLight(0xffffff, 0.7));
  var keyLight = new THREE.DirectionalLight(0xffffff, 1.1);
  keyLight.position.set(3, 5, 6);
  scene.add(keyLight);

  var geometry = new THREE.SphereGeometry(1, 20, 20);
  var balls = [];

  for (var i = 0; i < COUNT; i++) {
    var color = COLORS[i % COLORS.length];
    var material = new THREE.MeshStandardMaterial({
      color: color,
      roughness: 0.35,
      metalness: 0.05,
    });
    var mesh = new THREE.Mesh(geometry, material);
    var size = 0.22 + Math.random() * 0.3;
    mesh.scale.setScalar(size);
    mesh.position.set(
      (Math.random() * 2 - 1) * bounds.x,
      (Math.random() * 2 - 1) * bounds.y,
      (Math.random() * 2 - 1) * bounds.z,
    );
    scene.add(mesh);
    balls.push({
      mesh: mesh,
      radius: size,
      velocity: new THREE.Vector3(
        (Math.random() * 2 - 1) * 0.02,
        (Math.random() * 2 - 1) * 0.02,
        0,
      ),
    });
  }

  var pointerWorld = new THREE.Vector3(9999, 9999, 0);
  var pointerActive = false;
  var raycastPlane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
  var raycaster = new THREE.Raycaster();
  var pointerNDC = new THREE.Vector2();

  function onPointerMove(e) {
    var rect = container.getBoundingClientRect();
    if (
      e.clientX < rect.left ||
      e.clientX > rect.right ||
      e.clientY < rect.top ||
      e.clientY > rect.bottom
    ) {
      pointerActive = false;
      return;
    }
    pointerActive = true;
    pointerNDC.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    pointerNDC.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
    raycaster.setFromCamera(pointerNDC, camera);
    raycaster.ray.intersectPlane(raycastPlane, pointerWorld);
  }

  function onPointerLeave() {
    pointerActive = false;
  }

  function resize() {
    var rect = container.getBoundingClientRect();
    var width = rect.width || 1;
    var height = rect.height || 1;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);

    var vFov = (camera.fov * Math.PI) / 180;
    var visibleHeight = 2 * Math.tan(vFov / 2) * camera.position.z;
    var visibleWidth = visibleHeight * camera.aspect;
    bounds.x = visibleWidth / 2 - 0.5;
    bounds.y = visibleHeight / 2 - 0.5;
  }

  var tmpDir = new THREE.Vector3();

  function step() {
    for (var i = 0; i < balls.length; i++) {
      var ball = balls[i];
      var pos = ball.mesh.position;
      var vel = ball.velocity;

      vel.y += GRAVITY;

      if (pointerActive) {
        tmpDir.subVectors(pos, pointerWorld);
        tmpDir.z = 0;
        var dist = tmpDir.length();
        if (dist < CURSOR_RADIUS && dist > 0.0001) {
          tmpDir.normalize().multiplyScalar(((CURSOR_RADIUS - dist) / CURSOR_RADIUS) * CURSOR_FORCE);
          vel.add(tmpDir);
        }
      }

      vel.multiplyScalar(FRICTION);
      pos.add(vel);

      if (pos.x - ball.radius < -bounds.x) {
        pos.x = -bounds.x + ball.radius;
        vel.x = Math.abs(vel.x) * WALL_BOUNCE;
      } else if (pos.x + ball.radius > bounds.x) {
        pos.x = bounds.x - ball.radius;
        vel.x = -Math.abs(vel.x) * WALL_BOUNCE;
      }

      if (pos.y - ball.radius < -bounds.y) {
        pos.y = -bounds.y + ball.radius;
        vel.y = Math.abs(vel.y) * WALL_BOUNCE;
      } else if (pos.y + ball.radius > bounds.y) {
        pos.y = bounds.y - ball.radius;
        vel.y = -Math.abs(vel.y) * WALL_BOUNCE;
      }
    }
  }

  function animate() {
    if (!document.hidden) {
      step();
      renderer.render(scene, camera);
    }
    requestAnimationFrame(animate);
  }

  window.addEventListener('resize', resize);
  window.addEventListener('pointermove', onPointerMove, { passive: true });
  window.addEventListener('pointerleave', onPointerLeave, { passive: true });

  resize();
  animate();
})();
